var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _linearGradient29, _linearGradient30, _linearGradient31, _linearGradient32, _path, _circle, _circle2, _path2, _circle3, _circle4, _path3, _circle5, _circle6, _path4, _circle7, _circle8, _path5, _circle9, _circle10, _path6, _circle11, _circle12, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _circle13;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconOnlineEducation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 216.2,
    x2: 324.2,
    y1: 314.493,
    y2: 477.493
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#18cffc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4a98f7"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9f7fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0ddfc"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 276.483,
    x2: 331.804,
    xlinkHref: "#lg1",
    y1: 65.211,
    y2: 120.533
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 296.719,
    x2: 258.065,
    xlinkHref: "#lg2",
    y1: 85.448,
    y2: 46.793
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f0ddfc",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2085,
    stopColor: "#dfcdf1",
    stopOpacity: 0.209
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6167,
    stopColor: "#b5a4d3",
    stopOpacity: 0.617
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8779b3"
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 293.948,
    x2: 352.66,
    xlinkHref: "#lg3",
    y1: 97.563,
    y2: -11.635
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 346.5,
    x2: 435.134,
    xlinkHref: "#lg1",
    y1: 107.708,
    y2: 196.342
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 378.922,
    x2: 316.991,
    xlinkHref: "#lg2",
    y1: 140.13,
    y2: 78.199
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 374.482,
    x2: 468.548,
    xlinkHref: "#lg3",
    y1: 159.541,
    y2: -15.41
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 160.895,
    x2: 263.136,
    xlinkHref: "#lg1",
    y1: 49.405,
    y2: 151.645
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 198.295,
    x2: 126.857,
    xlinkHref: "#lg2",
    y1: 86.804,
    y2: 15.366
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 193.173,
    x2: 301.68,
    xlinkHref: "#lg3",
    y1: 109.194,
    y2: -92.614
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 364.864,
    x2: 501.657,
    xlinkHref: "#lg1",
    y1: 199.414,
    y2: 336.206
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 414.903,
    x2: 319.322,
    xlinkHref: "#lg2",
    y1: 249.452,
    y2: 153.872
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 408.05,
    x2: 553.227,
    xlinkHref: "#lg3",
    y1: 279.409,
    y2: 9.4
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 218.851,
    x2: 385.932,
    xlinkHref: "#lg1",
    y1: 167.277,
    y2: 334.359
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 279.969,
    x2: 163.225,
    xlinkHref: "#lg2",
    y1: 228.396,
    y2: 111.651
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 271.599,
    x2: 448.921,
    xlinkHref: "#lg3",
    y1: 264.986,
    y2: -64.81
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 115.86,
    x2: 194.792,
    xlinkHref: "#lg1",
    y1: 201.144,
    y2: 389.615
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 136.342,
    x2: 24.135,
    xlinkHref: "#lg2",
    y1: 232.91,
    y2: 120.703
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffda45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa425"
  }))), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 360.284,
    x2: 393.284,
    xlinkHref: "#lg4",
    y1: 405.38,
    y2: 449.38
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 387.957,
    x2: 419.29,
    xlinkHref: "#lg4",
    y1: 417.137,
    y2: 465.804
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 390.477,
    x2: 415.143,
    xlinkHref: "#lg4",
    y1: 459.93,
    y2: 506.597
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 378.32,
    x2: 555.32,
    y1: 491.805,
    y2: 308.805
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffda45",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b53759"
  }))), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 415.22,
    x2: 328.779,
    y1: 467.473,
    y2: 397.521
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffda45",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5955,
    stopColor: "#fde82c",
    stopOpacity: 0.596
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fcee21"
  }))), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg5"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0469bc",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0469bc"
  }))), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 208.78,
    x2: 199.78,
    xlinkHref: "#lg5",
    y1: 435.309,
    y2: 394.559
  })), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 231.606,
    x2: 204.356,
    xlinkHref: "#lg5",
    y1: 375.816,
    y2: 413.066
  })), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 123.991,
    x2: 123.991,
    y1: 337.497,
    y2: 296.976
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#18cffc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  }))), _linearGradient32 || (_linearGradient32 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 123.991,
    x2: 123.991,
    xlinkHref: "#lg3",
    y1: 274.5,
    y2: 368.608
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m243.45 491.75h-1.904c-27.044 0-49.046-22.002-49.046-49.046v-20.745c0-1.107.026-2.206.079-3.301h-17.144c-35.259 0-63.945-28.686-63.945-63.945v-56.64h25v56.64c0 21.475 17.471 38.945 38.945 38.945h23.252c10.747-23.321 34.345-39.548 61.662-39.548h104.681c22.107 0 40.094 17.986 40.094 40.094h-25c0-8.322-6.771-15.094-15.094-15.094h-104.68c-12.79 0-24.29 5.633-32.147 14.548h15.248c27.044 0 49.046 22.002 49.046 49.046s-22.003 49.046-49.047 49.046zm-25.824-73.092c-.083 1.09-.126 2.19-.126 3.301l.126 20.745c0 13.259 10.661 24.046 23.92 24.046h1.904c13.259 0 24.046-10.787 24.046-24.046s-10.787-24.046-24.046-24.046z",
    fill: "url(#SVGID_1_)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 292.464,
    cy: 81.193,
    fill: "url(#SVGID_2_)",
    r: 42.714
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 292.464,
    cy: 81.193,
    fill: "url(#SVGID_3_)",
    r: 35.649
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m311.572 42.983c2.881 5.75 4.505 12.238 4.505 19.107 0 23.59-19.124 42.714-42.714 42.714-6.869 0-13.358-1.624-19.107-4.505 7.013 13.997 21.488 23.607 38.209 23.607 23.59 0 42.714-19.124 42.714-42.714 0-16.721-9.61-31.196-23.607-38.209z",
    fill: "url(#SVGID_4_)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 372.105,
    cy: 133.313,
    fill: "url(#SVGID_5_)",
    r: 68.435
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 372.105,
    cy: 133.313,
    fill: "url(#SVGID_6_)",
    r: 57.115
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m402.718 72.096c4.616 9.212 7.217 19.608 7.217 30.613 0 37.795-30.639 68.435-68.435 68.435-11.005 0-21.401-2.602-30.613-7.217 11.236 22.425 34.427 37.822 61.217 37.822 37.795 0 68.435-30.639 68.435-68.435.001-26.791-15.396-49.982-37.821-61.218z",
    fill: "url(#SVGID_7_)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 190.431,
    cy: 78.94,
    fill: "url(#SVGID_8_)",
    r: 78.94
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 190.431,
    cy: 78.94,
    fill: "url(#SVGID_9_)",
    r: 65.883
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m225.743 8.325c5.324 10.626 8.325 22.618 8.325 35.312 0 43.598-35.343 78.94-78.94 78.94-12.694 0-24.686-3.001-35.312-8.325 12.961 25.868 39.712 43.628 70.615 43.628 43.598 0 78.94-35.343 78.94-78.94.001-30.903-17.76-57.654-43.628-70.615z",
    fill: "url(#SVGID_10_)"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 404.382,
    cy: 238.931,
    fill: "url(#SVGID_11_)",
    r: 105.618
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 404.382,
    cy: 238.931,
    fill: "url(#SVGID_12_)",
    r: 88.147
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m451.628 144.452c7.124 14.217 11.139 30.261 11.139 47.246 0 58.331-47.287 105.618-105.618 105.618-16.984 0-33.029-4.015-47.246-11.139 17.341 34.61 53.133 58.372 94.48 58.372 58.331 0 105.618-47.287 105.618-105.618-.001-41.347-23.763-77.138-58.373-94.479z",
    fill: "url(#SVGID_13_)"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 267.119,
    cy: 215.545,
    fill: "url(#SVGID_14_)",
    r: 129.005
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 267.119,
    cy: 215.545,
    fill: "url(#SVGID_15_)",
    r: 107.665
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m324.826 100.146c8.701 17.365 13.605 36.962 13.605 57.707 0 71.247-57.757 129.005-129.005 129.005-20.745 0-40.342-4.904-57.707-13.605 21.181 42.273 64.897 71.297 115.399 71.297 71.247 0 129.005-57.757 129.005-129.005 0-50.502-29.024-94.219-71.297-115.399z",
    fill: "url(#SVGID_16_)"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 123.991,
    cy: 220.558,
    fill: "url(#SVGID_17_)",
    r: 123.991
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 123.991,
    cy: 220.558,
    fill: "url(#SVGID_18_)",
    r: 103.481
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m401.521 510h-17.794c-22.424 0-40.603-18.179-40.603-40.603v-41.794c0-22.424 18.179-40.603 40.603-40.603h17.794c22.424 0 40.603 18.179 40.603 40.603v41.794c0 22.424-18.179 40.603-40.603 40.603z",
    fill: "url(#SVGID_19_)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m401.521 387h-8.897v123h8.897c22.424 0 40.603-18.178 40.603-40.603v-41.794c0-22.425-18.179-40.603-40.603-40.603z",
    fill: "url(#SVGID_20_)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m343.124 448.5v20.897c0 22.425 18.179 40.603 40.603 40.603h17.794c22.424 0 40.603-18.178 40.603-40.603v-20.897z",
    fill: "url(#SVGID_21_)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m418.203 390.588c1.669 4.441 2.587 9.25 2.587 14.274v41.794c0 22.424-18.179 40.603-40.603 40.603h-17.794c-5.948 0-11.592-1.29-16.682-3.588 5.778 15.381 20.616 26.329 38.016 26.329h17.794c22.424 0 40.603-18.178 40.603-40.603v-41.794c0-16.477-9.82-30.65-23.921-37.015z",
    fill: "url(#SVGID_22_)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m408.725 394.204h-17.794c-22.424 0-40.603 18.179-40.603 40.603v41.794c0 9.376 3.186 18.002 8.524 24.875 6.873 5.337 15.499 8.523 24.875 8.523h17.794c22.424 0 40.603-18.178 40.603-40.603v-41.794c0-9.376-3.186-18.002-8.524-24.875-6.873-5.337-15.499-8.523-24.875-8.523z",
    fill: "url(#SVGID_23_)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m217.626 418.658h-25.047l25.047 24.484z",
    fill: "url(#SVGID_24_)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m249.75 380.453v-25.508c-22.721 3.58-41.734 18.47-51.063 38.713h29.515c5.61-6.364 13.082-11.042 21.548-13.205z",
    fill: "url(#SVGID_25_)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m111.491 344.925c4.111.412 8.281.625 12.5.625s8.389-.213 12.5-.625v-46.851h-25z",
    fill: "url(#SVGID_26_)"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 123.991,
    cy: 262.281,
    fill: "url(#SVGID_27_)",
    r: 44.812
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOnlineEducation);
export default __webpack_public_path__ + "static/media/icon-online-education.4f8ad9f7fb84f39268a1db1c21033036.svg";
export { ForwardRef as ReactComponent };